import Vue from 'vue'
import * as jsonpatch from 'fast-json-patch/index.mjs'

const luSession = {
  actions: {
    async updateSessionBills(context, payload) {
      const url = `LuSession/UpdateBillStatus/${payload}`
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: res.data },
          { root: true }
        )
        //if you will always need to reload the list after a delete
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadLuSessions')
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
  },
}

export default luSession
